import { Breadcrumb, Col, Row, Steps } from "antd";
import { _adr } from "../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { Link } from "react-router-dom";

const CDReviewRequest = () => {
	const [t] = useTranslation("global");
	return (
		<>
			<style>{`.page_body {
		margin: 1rem 0 2rem;
		.label {
			margin-right: 1rem;
			color: #303030;
			text-align: right;
			font-size: 1rem;
			font-style: normal;
			font-weight: 700;
			margin-top: 1rem;
			margin-bottom: 1rem;
			display: block;
		}
		.value {
			margin-right: 1rem;
			color: #4d4d4d;
			font-size: 1rem;
			font-style: normal;
			font-weight: 400;
			line-height: normal;
			word-break: break-word;
		}
		.noteMsg {
			display: flex;
			gap: 0.5rem;
			&::before {
				content: "";
				background-color: #e64225;
				width: 0.5625rem;
				height: 0.5625rem;
				border-radius: 50%;
				margin: auto 0;
			}
		}
	}`}</style>
			<div className="container-main container-cw">
				<div className="holder-top-of-page-content">
					<div className="g-hold-title-of-page">
						<Breadcrumb
							className="breadcrumbs"
							items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("creditCard.title") }]}
						/>
						<div className="title-page">
							<h3>{t("creditCard.title")}</h3>
							<p></p>
						</div>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main da-container">
						<div className="g-format-page">
							<div className="g-format-steps">
								<div className="holder-step">
									<Steps
										size="small"
										className="step-wizard"
										current={4}
										responsive
										items={[
											{
												title: "ورود کدملی",
											},
											{
												title: "اطلاعات هویتی",
											},
											{
												title: "آپلود مدارک",
											},
											{
												title: "کارت بانکی",
											},
											{
												title: "بررسی نهایی",
											},
										]}
									/>
								</div>
							</div>
							<div className="page_body">
								<br />
								<div className="page_title">
									اطلاعات مشتری
									<Link to={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidKit}>
										<i className="icon-edit"></i>
									</Link>
								</div>
								<br />
								<div>
									<Row>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">نام و نام خانوادگی</div>
											<div className="value"></div>
										</Col>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">تاریخ تولد</div>
											<div className="value"></div>
										</Col>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">کدملی</div>
											<div className="value"></div>
										</Col>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">نام پدر</div>
											<div className="value"></div>
										</Col>
									</Row>
									<Row>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">جنسیت</div>
											<div className="value"></div>
										</Col>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">شماره شناسنامه</div>
											<div className="value"></div>
										</Col>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">شماره پاسپورت</div>
											<div className="value"></div>
										</Col>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">وضعیت پرداخت</div>
											<div className="value"></div>
										</Col>
									</Row>
									<Row>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">وضعیت پروفایل</div>
											<div className="value"></div>
										</Col>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">وضعیت طرح</div>
											<div className="value"></div>
										</Col>
									</Row>
								</div>
								<hr />
								<br />
								<div className="page_title">
									تصویر مدارک
									<Link to={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidKit}>
										<i className="icon-edit"></i>
									</Link>
								</div>
								<br />
								<div>
									<Row>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">تصویر پاسپورت</div>
											<div className="value"></div>
										</Col>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">تصویر قرارداد</div>
											<div className="value"></div>
										</Col>
									</Row>
								</div>
								<hr />
								<br />
								<div className="page_title">
									اطلاعات کارت بانکی
									<Link to={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidKit}>
										<i className="icon-edit"></i>
									</Link>
								</div>
								<br />
								<div>
									<Row>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">شماره کارت</div>
											<div className="value"></div>
										</Col>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">CVV</div>
											<div className="value"></div>
										</Col>
										<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
											<div className="label">تاریخ انقضا</div>
											<div className="value"></div>
										</Col>
									</Row>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default CDReviewRequest;
